<template>
  <div style="text-align: left">
    <div style="margin-bottom: 10px">
      <el-button
        type="primary"
        v-role="['1', '3']"
        class="add"
        size="small"
        @click="addPlayerChatSet"
      >
        <i class="el-icon-plus"></i>
        新增设置
      </el-button>
      <el-button
        type="danger"
        v-role="['1', '3']"
        size="small"
        class="delete"
        @click="delMulData"
      >
        <i class="el-icon-delete"></i>删除
      </el-button>
    </div>
    <div>
      <div class="box">
        <el-form :inline="true" size="mini">
          <el-form-item>
            <el-input
              placeholder="请输入名称"
              clearable
              v-model="searchForm.name"
            ></el-input>
          </el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="doSearch"
            class="queryBtn"
            >查询</el-button
          >
        </el-form>
      </div>
    </div>
    <el-table
      ref="multipleTable"
      :data="tableListData"
      tooltip-effect="dark"
      style="width: 100%; position: relative"
      border
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        min-width="40"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="name"
        align="center"
        label="名称"
      ></el-table-column>
      <el-table-column
        prop="minAge"
        align="center"
        label="最小年龄"
      ></el-table-column>
      <el-table-column
        prop="maxAge"
        align="center"
        label="最大年龄"
      ></el-table-column>
      <el-table-column
        prop="operation"
        label="操作"
        width="100"
        fixed="right"
        v-role="['1', '3']"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            v-role="['1', '3']"
            @click="deletePlayerChatSet(scope.row)"
            class="btn"
            size="small"
            >删除</el-button
          >
          <el-button
            type="text"
            size="small"
            v-role="['1', '3']"
            @click="editPlayerChatSet(scope.row)"
            class="btn"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="paging">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[15, 20, 50, 100]"
        :page-size="searchForm.pageSize"
        background
        layout="prev, pager, next,total, sizes, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <!--新增弹框-->
    <el-dialog
      :title="'新增设置项'"
      :inline="true"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        :model="form"
        label-position="right"
        label-width="110px"
        :rules="formRules"
        ref="form"
      >
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="最小年龄" prop="minAge">
          <el-input-number
            v-model="form.minAge"
            min="0"
            :controls="false"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="最大年龄" prop="maxAge">
          <el-input-number
            v-model="form.maxAge"
            min="0"
            :controls="false"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm" :loading="isLoading"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from '../apis/playerchart'
export default {
  props: ['matchId'],
  data () {
    return {
      isLoading: false,
      dialogFormVisible: false,
      multipleSelection: [],
      total: 0,
      tableListData: [],
      searchForm: {
        matchId: this.matchId,
        page: 1,
        pageSize: 15,
      },
      form: {
        id: 0,
        name: '',
        amount: '',
        rate: '',
        matchId: this.matchId
      },
      formRules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }]
      }
    }
  },
  methods: {
    editPlayerChatSet (row) {
      this.formTitle = "编辑";
      API.get({ id: row.id }).then(result => {
        this.dialogFormVisible = true
        this.form = Object.assign({}, result.result)
      })
    },
    addPlayerChatSet () {
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['form'].resetFields()
        this.form.matchId = this.matchId
      })
    },
    handleSizeChange: function (val) {
      this.searchForm.pageSize = val;
      this.search()
    },
    handleCurrentChange: function (val) {
      this.searchForm.page = val;
      this.search()
    },
    doSearch () {
      this.searchForm.page = 1
      this.search()
    },
    search: function () {
      let params = Object.assign({}, this.searchForm);
      API.getList(params).then((result) => {
        if (result && result.code == 0) {
          this.tableListData = result.result.data;
          this.total = result.result.recordCount;
        }
        else {
          this.$message.error({ showClose: true, message: result.result.message, duration: 2000 });
        }
      }).catch((error) => {
        this.$message.error({ showClose: true, message: '请求出现异常', duration: 2000 });
      });
    },

    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    submitForm () {
      let that = this;
      this.isLoading = true
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.form)
          if (params.id > 0) {
            API.edit(params).then((data) => {
              if (data.code == 0) {
                that.$message.success({ showClose: true, message: '更改成功', duration: 2000 });
                that.dialogFormVisible = false;
                that.$refs['form'].resetFields();
                that.search();
              } else {
                this.$message.error({ showClose: true, message: data.message, duration: 2000 });
              }
              that.isLoading = false
            }, function (err) {
              that.$message.error({ showClose: true, message: err.toString(), duration: 2000 });
              that.isLoading = false
            }).catch(function (error) {
              that.$message.error({ showClose: true, message: '请求出现异常', duration: 2000 });
              that.isLoading = false
            })
          }
          else {
            API.add(params).then(result => {
              if (result.code == 0) {
                this.$message.success({ showClose: true, message: '新增成功', duration: 2000 });
                this.$refs['form'].resetFields();
                this.dialogFormVisible = false;
                this.search();
                this.isLoading = false
              } else {
                this.$message.error({ showClose: true, message: result.message, duration: 2000 });
                this.isLoading = false
              }
            }).catch((error) => {
              this.$message.error({ showClose: true, message: '请求异常', duration: 2000 });
              this.isLoading = false
            });
          }
        }
        else {
          this.isLoading = false
        }
      });
    },
    deletePlayerChatSet (row) {
      let params = { id: row.id };
      this.$confirm('确认删除记录吗？', '提示', { type: 'warning' }).then(() => {
        API.delete(params).then((result) => {
          if (result.code == 0) {
            this.$message.success({ showClose: true, message: '删除成功', duration: 2000 });
            this.search();
          } else {
            this.$message.error({ showClose: true, message: result.message, duration: 2000 });
          }
        }).catch((error) => {
          this.$message.error({ showClose: true, message: '123', duration: 2000 })
        })
      }).catch(() => { })
    },
    /*批量删除*/
    delMulData () {
      let that = this;
      let val = that.multipleSelection
      let idArray = [];
      for (var i = 0; i < val.length; i++) {
        idArray.push(val[i].id)
      }
      this.$confirm('此操作将永久删除该数据，是否继续？', '提示', {
        confimButtonTexe: '确定',
        cancelButtonTexe: '取消',
        type: 'warning'
      }).then(() => {
        if (idArray) {
          API.deleteBatch({ ids: idArray.join() }).then(function (result) {
            that.loading = false;
            if (result && result.code == 0) {
              that.$message.success({ showClose: true, message: '删除成功', duration: 2000 });
              that.search()
            } else {
              that.$message.error({ showClose: true, message: '删除操作异常，请重试', duration: 2000 });
            }
          }, function (err) {
            that.loading = false;
            that.$message.error({ showClose: true, message: err.toString(), duration: 2000 });
          }).catch(function (error) {
            that.loading = false;
            that.$message.error({ showClose: true, message: '请求出现异常', duration: 2000 });
          })
        }
      })
      this.$refs.multipleTable.clearSelection()
    }
  },
  mounted () {
    this.search()
  }
}
</script>


// WEBPACK FOOTER //
// src/components/PlayerChartSet.vue